const ENDPOINT = 'POSTregisterattempt';
function postDashboardRegisterAttempt(gateway, params) {
    return gateway.post(postDashboardRegisterAttempt.endpoint, params, params, null, null, 'json');
}
postDashboardRegisterAttempt.endpoint = ENDPOINT;

export { postDashboardRegisterAttempt as default };
//# sourceMappingURL=postDashboardRegisterAttempt.js.map
